import {ContentContainer} from '@coolcolduk/ui-mui';
import LoginForm from './LoginForm';

export default function LoginPage() {
  return (
    <ContentContainer data-testid="login-page" center>
      <LoginForm />
    </ContentContainer>
  );
}
